import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading, verificationError, retryVerification } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loader"></div>
      </div>
    );
  }

  // A genuine authentication failure (401/403) redirects to login.
  if (!user && !verificationError) {
    return <Navigate to="/admin/login" replace />;
  }

  // Temporary server/network problem while verifying credentials.
  // Show a retry state instead of silently forcing a logout.
  if (verificationError && !user) {
    return (
      <div className="loading-screen" style={{ flexDirection: 'column', gap: 16 }}>
        <div className="loader"></div>
        <p>Could not verify your session. Check your connection and try again.</p>
        <button
          type="button"
          className="btn btn-primary"
          onClick={retryVerification}
        >
          Retry
        </button>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;